import { useSystemStore } from '@/stores/system'
import apiClient from './apiClient'

export interface ApiResponse<T> {
  data: T
  status: number
}

export const http = {
  get: async <T>(url: string, params?: object): Promise<ApiResponse<T>> => {
    try {
      const res = await apiClient.get<T>(url, { params })
      return { data: res.data, status: res.status }
    } catch (error) {
      const systemStore = useSystemStore()
      systemStore.setError(error as Error)
      throw error
    }
  },

  post: async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
    try {
      const res = await apiClient.post<T>(url, body)
      return { data: res.data, status: res.status }
    } catch (error) {
      const systemStore = useSystemStore()
      systemStore.setError(error as Error)
      throw error
    }
  },

  put: async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
    try {
      const res = await apiClient.put<T>(url, body)
      return { data: res.data, status: res.status }
    } catch (error) {
      const systemStore = useSystemStore()
      systemStore.setError(error as Error)
      throw error
    }
  },

  patch: async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
    try {
      const res = await apiClient.patch<T>(url, body)
      return { data: res.data, status: res.status }
    } catch (error) {
      const systemStore = useSystemStore()
      systemStore.setError(error as Error)
      throw error
    }
  },

  delete: async <T>(url: string, data?: object): Promise<ApiResponse<T>> => {
    try {
      const res = await apiClient.delete<T>(url, { data })
      return { data: res.data, status: res.status }
    } catch (error) {
      const systemStore = useSystemStore()
      systemStore.setError(error as Error)
      throw error
    }
  },
}
